import Vue from 'vue'
import Router from 'vue-router'
import Load from './views/Loading.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'load',
      component: Load
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/main',
      name: 'main',
      component: () => import('./views/Main.vue')
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('./views/Code.vue')
    },
    {
      path: '/current',
      name: 'current',
      component: () => import('./views/Current.vue')
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('./views/Join.vue')
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: () => import('./views/Mypage.vue')
    },
    {
      path: '/lot',
      name: 'lot',
      component: () => import('./views/Lot.vue')
    },
    {
      path: '/input',
      name: 'input',
      component: () => import('./views/Input.vue')
    },
    {
      path: '/succ',
      name: 'succ',
      component: () => import('./views/Succ.vue')
    },
    {
      path: '/outhome',
      name: 'outhome',
      component: () => import('./views/Outhome.vue')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('./views/Sharetop.vue')
    },
    {
      path: '/joins',
      name: 'joins',
      component: () => import('./views/Joins.vue')
    }
  ]
})
